import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  styled,
  useTheme,
} from "@mui/material";

import CommonButton from "../CommonButton";

interface RemarksDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  initialRemarks: string | null;
  onChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
}

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    maxWidth: "400px",
    width: "90%",
    margin: "16px",
    borderRadius: "10px",
    position: "relative", // Add this to ensure absolute positioning works correctly
  },
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "17px",
    backgroundColor: theme.palette.secondary.main,
    fontFamily: "Nunito Sans Regular500",
    mt: "10px",
    "& fieldset": {
      BorderColor: theme.palette.secondary.dark,
    },
  },
}));

const CloseButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  right: "16px",
  top: "16px",
  zIndex: 1,
}));

const RemarksDialog: React.FC<RemarksDialogProps> = ({
  open,
  onClose,
  onSave,
  initialRemarks,
  onChange,
}) => {
  const theme = useTheme();

  return (
    <StyledDialog open={open} onClose={onClose}>
      <CloseButton
        aria-label="close"
        onClick={onClose}
        sx={{ color: "text.secondary" }}
      >
        <img
          src={"/assets/ic_alert_close.svg"}
          alt={`close-icon`}
          width="16px"
          height="16px"
        />
      </CloseButton>

      <DialogContent sx={{ pt: 4 }}>
        <StyledTextField
          autoFocus
          id="remarks"
          multiline
          rows={3}
          fullWidth
          variant="outlined"
          value={initialRemarks ?? ""}
          onChange={onChange}
          sx={{ mt: "16px" }}
          placeholder="Let op! Deze informatie is ook zichtbaar voor de opdrachtgever."
        />
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "flex-end",
          mr: "30px",
          pb: 1,
        }}
      >
        <CommonButton
          translationKey={"common.button_opslaan"}
          type="submit"
          onClick={onSave}
          sx={{
            borderRadius: "6px",
            width: "auto",
            padding: "8px 8px",
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.secondary.main,
            fontFamily: "Nunito Sans Regular500",
            fontWeight: 700,
          }}
        />
      </DialogActions>
    </StyledDialog>
  );
};

export default RemarksDialog;
